import apiFactory from '@/api/default';
const API = apiFactory('states');

const state = {};

const getters = {};

const mutations = {};

const actions = {

  async deleteState({commit}, id) {
    const response = await API.remove(id);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
